import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportAcoesCorretivasUseCase } from "../../../presentation/useCases/read/get_report_acoes_corretivas_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

//GetReportAcoesCorretivasUseCase
export class GetReportAcoesCorretivasUseCase implements IGetReportAcoesCorretivasUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportAcoesCorretivas(IdAcaoQualidade: number, requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportAcoesCorretivas(IdAcaoQualidade,requiredMimeType);

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `acoes_corretivas_${IdAcaoQualidade}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
